// Copyright (c) 2021, Comsearch, Inc., All rights reserved

const getVisibleSegmentEndIds = () => (dispatch, getState) => {
  const { bulkEdit } = getState()

  const bulkEditPaths = bulkEdit.get('bulkEditPaths')
  const visiblePathIds = bulkEdit.get('visiblePathIds')

  return (
    bulkEditPaths
      // get all the visible paths' data objects
      .filter(d => visiblePathIds.includes(d.get('pathId')))
      // then get their sites' ids so we can highlight them.
      .reduce((a, d) => {
        a.push(
          d.getIn(['site1', 'segmentEndId']),
          d.getIn(['site2', 'segmentEndId']),
        )
        return a
      }, [])
  )
}

export default getVisibleSegmentEndIds
